module.exports = __webpack_public_path__ + "img/en_text.4ddc5a5f.svg";